












































































import { Component, Mixins, Emit } from "vue-property-decorator";
import { Rectangle, Point, Size } from "../../domain/drawing";
import { RectangleDragHandlesMixin } from "./mixins";
import RectangleResizeDragHandle from "./RectangleResizeDragHandle.vue";
import MoveDragHandleArea from "./MoveDragHandleArea.vue";
import MoveDragHandle from "./MoveDragHandle.vue";

@Component({
  components: {
    RectangleResizeDragHandle,
    MoveDragHandleArea,
    MoveDragHandle,
  },
})
export default class TextBoxDragHandles extends Mixins(RectangleDragHandlesMixin) {
  get rectangle(): Rectangle {
    return new Rectangle(
      new Point(0, 0),
      this.size
    );
  }

  @Emit()
  click(event: PointerEvent): void {}

  @Emit()
  dblclick(event: PointerEvent): void {}

  @Emit()
  clickPrevented(event: PointerEvent): void {}

  @Emit()
  dblclickPrevented(event: PointerEvent): void {}

  toMoveHandleLocation(handleSize: Size): Point {
    return new Point(
      handleSize.width / 2 + 1,
      -handleSize.height / 2
    );
  }
}
